import CommonService from './common.service'

class CountryService extends CommonService {
  async all() {
    return await this.get('/countries')
  }
}

export const countryService = new CountryService()
